import { useState } from "react";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐字段,若被填充则静默放行,不真正提交
    const honey = (data.get("website_alt") as string) || "";
    if (honey.trim() !== "") {
      setStatus("success");
      form.reset();
      return;
    }
    data.delete("website_alt");

    setStatus("loading");
    setFormError("");

    try {
      const res = await fetch("https://readdy.ai/api/form/da1b15drlbpoffc5h3ag", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || "";
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg && !serverMsg.includes("spam") ? serverMsg : "提交失败,请稍后再试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常,请检查网络后重试。");
    }
  }

  return (
    <section id="subscribe" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
          <i className="ri-notification-3-line"></i>
          Stay Updated
        </span>
        <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
          订阅作品更新
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          留下你的邮箱,每周新作的娜美同人插画与壁纸上新时,我们会第一时间通知你。
        </p>

        <form
          data-readdy-form="true"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex w-full max-w-xl flex-col gap-3 sm:flex-row"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="请输入你的邮箱地址"
            className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 cursor-pointer"
          >
            {status === "loading" ? (
              <>
                <i className="ri-loader-4-line animate-spin"></i>
                提交中
              </>
            ) : (
              <>
                订阅更新
                <i className="ri-mail-send-line"></i>
              </>
            )}
          </button>
          <input
            type="text"
            name="website_alt"
            autoComplete="off"
            tabIndex={-1}
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
        </form>

        {status === "success" && (
          <p className="mt-4 flex items-center justify-center gap-1.5 text-sm text-primary-600">
            <i className="ri-checkbox-circle-line"></i>
            订阅成功,感谢你的关注!
          </p>
        )}
        {status === "error" && formError && (
          <p className="mt-4 flex items-center justify-center gap-1.5 text-sm text-secondary-700">
            <i className="ri-error-warning-line"></i>
            {formError}
          </p>
        )}
      </div>
    </section>
  );
}